import trackAddToBag from "./trackAddToBag";

const initialiseOptimizelyTracking = () => {
  trackAddToBag();
};

export default initialiseOptimizelyTracking;
